// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"App_pageContainer__IMjRo"};